import { ReactNode } from "react";
import { styled } from "@mui/material";
import {
  GRAYPALEBACKGROUND2,
  GRAYPALESTROKE,
  GRAYPALETITLE,
} from "../../../styles/color";

export interface HintItem {
  /** 키보드 키 모양으로 보여줄 글자 (예: ["←", "→"]) */
  keys?: string[];
  /** 키 대신 보여줄 아이콘 (휴대폰 손가락 동작 등) */
  icon?: ReactNode;
  label: string;
}

interface ControlHintsProps {
  items: HintItem[];
  align?: "center" | "flex-start" | "flex-end";
}

/**
 * 조작법 안내 줄. 작은 회색 글씨로 쓰면 눈에 띄지 않아서, 회색 띠 위에
 * 키보드 키 모양과 손가락 아이콘으로 보여준다.
 */
function ControlHints({ items, align = "center" }: ControlHintsProps) {
  if (items.length === 0) return null;
  return (
    <Bar style={{ justifyContent: align }} aria-label="조작법">
      {items.map((item) => (
        <Item key={item.label}>
          {item.icon}
          {item.keys?.map((key) => (
            <Kbd key={key}>{key}</Kbd>
          ))}
          <Label>{item.label}</Label>
        </Item>
      ))}
    </Bar>
  );
}

export default ControlHints;

const Bar = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "6px 18px",
  padding: "8px 12px",
  borderRadius: "8px",
  backgroundColor: GRAYPALEBACKGROUND2,
});

const Item = styled("span")({
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  color: GRAYPALETITLE,
  "& svg": { fontSize: "20px", color: GRAYPALETITLE },
});

export const Kbd = styled("kbd")({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "24px",
  height: "24px",
  padding: "0 6px",
  borderRadius: "5px",
  border: `1px solid ${GRAYPALESTROKE}`,
  borderBottomWidth: "2px",
  backgroundColor: "#fff",
  color: GRAYPALETITLE,
  fontFamily: "inherit",
  fontSize: "0.8rem",
  fontWeight: 600,
  lineHeight: 1,
  boxShadow: "none",
});

const Label = styled("span")({
  marginLeft: "2px",
  fontSize: "0.85rem",
  fontWeight: 500,
  color: GRAYPALETITLE,
  whiteSpace: "nowrap",
});
